export const SEND_ORDER = "SEND_ORDER"

export const sendOrderAction = (payload) => ({ type: SEND_ORDER, payload })